var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.boxShow)?_c('box',{ref:_vm.boxRef,attrs:{"title":"线上商品","width":1000,"index":2,"moduleName":"goods","group":"offer_goods","store":_vm.store,"selectType":"checkbox","buttonShow":false},on:{"hide":_vm.hide}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }